var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
var InventoryManager = /** @class */ (function () {
    function InventoryManager() {
        /*
        inventory: any = {
            "0000000S23062": 0,
            "0000000S23149": -1000,
            "0000000S23034": -1000,
            "0000000A38003": -1000
        };*/
        this.inventory = {};
        this.version = 0;
    }
    InventoryManager.prototype.isEmpty = function () {
        return Object.keys(this.inventory).length === 0;
    };
    InventoryManager.prototype.getInv = function (item) {
        var q = null;
        var liveInv = this.inventory;
        if (liveInv && !this.isEmpty()) {
            q = this.getQty(liveInv, item.backendId); // liveInv[item.backendId];
            if (q == null)
                q = this.getQty(liveInv, item.id); //liveInv[item.id];
            if (q == null)
                q = -1;
        }
        else {
            q = item.inventory;
        }
        return q;
    };
    InventoryManager.prototype.isHidden = function (item) {
        var qty = this.getInv(item);
        if (qty == -1000) {
            return true;
        }
        return false;
    };
    InventoryManager.prototype.getQty = function (inv, itemid) {
        var qty = inv[itemid];
        if (typeof qty === 'undefined') {
            return null;
        }
        return qty;
    };
    InventoryManager.prototype.isPublish = function (item) {
        /*
        if (!this.inventory) {
            return item.published;
        }*/
        //let qty = this.inventory[id];
        var qty = this.getInv(item);
        if (qty == -1000) {
            return false;
        }
        return item.published;
        /*
        console.log(item.name, qty);

        if (typeof qty === 'undefined') {
            return item.published;
        }

        let publish: boolean = <number>qty != -1000;
        if (!publish) return false;
        return true;
        */
    };
    //?why does it exist???
    /*
    soldout(item: Item) {

        let id: string = item.id;

        if (item.backendId)
            id = item.backendId;

        this.inventory[id] = 0;
    }
    */
    /*
    isSoldout(item: Item): boolean {

        let id: string = item.id;

        if (item.backendId)
            id = item.backendId;

        let qty = this.inventory[id];

        if (typeof qty === 'undefined') return false;

        let soldout: boolean = <number>qty == 0;
        return soldout;
    }*/
    InventoryManager.prototype.isSoldout = function (item, qty) {
        if (qty === void 0) { qty = 1; }
        var inv = this.getInv(item);
        //console.log(item.name, item, inv);
        if (inv == -1)
            return false; //-1=unlimited
        if (inv <= 0)
            return true;
        return qty > inv;
    };
    InventoryManager.prototype.getSoldoutCount = function (items, qty) {
        if (qty === void 0) { qty = 1; }
        var count = 0;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var soldout = this.isSoldout(item, qty);
            if (soldout) {
                count++;
            }
        }
        return count;
    };
    InventoryManager.prototype.set = function (inventory, version) {
        console.log("inventory", inventory, version);
        if (!inventory)
            inventory = {};
        this.inventory = inventory;
        this.version = version;
    };
    InventoryManager.prototype.needUpdate = function (version) {
        console.log("inv version:" + version + ">" + this.version);
        var update = version > this.version;
        console.log("need update inv", update);
        return update;
    };
    InventoryManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], InventoryManager);
    return InventoryManager;
}());
export { InventoryManager };
//# sourceMappingURL=inventory-manager.js.map